// Import basic js
require('./frontend');
// Import template specific js
require('./templatestyles/default/default');